import { render } from "./DiscountCopy.vue?vue&type=template&id=23ebdf36&scoped=true"
import script from "./DiscountCopy.vue?vue&type=script&lang=js"
export * from "./DiscountCopy.vue?vue&type=script&lang=js"

import "./DiscountCopy.vue?vue&type=style&index=0&id=23ebdf36&lang=scss&scoped=true"

import exportComponent from "/Users/marc.bush/Sites/ensotyres/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23ebdf36"]])

export default __exports__